import { BrandPrefix } from '@amzn/awsdev-docs-virtual-smiley-typescript-client';
import { FormField, Select } from '@amzn/awsui-components-react';
import { OptionDefinition } from '@amzn/awsui-components-react/polaris/internal/components/option/interfaces';
import { ReactElement, useEffect, useState } from 'react';
import { FieldProps } from '../FieldProps';
const empty: OptionDefinition = {
  value: undefined,
  label: 'Select...',
};
const options = Object.entries(BrandPrefix).map(([, label]) => ({
  value: label,
  label,
}));

export const BrandPrefixField = (
  props: FieldProps<BrandPrefix | undefined, true>
): ReactElement => {
  const [valid, setValid] = useState(false);
  useEffect(() => setValid(true), [props.value, props.required]);
  useEffect(() => props.onValidate?.(valid), [valid]);
  return (
    <FormField label='Brand prefix'>
      {props.old && props.old !== props.value && (
        <Select
          disabled={props.disabled}
          options={[empty, ...options]}
          selectedOption={
            typeof props.old === 'string'
              ? options.find((o) => o.label === props.old) ?? empty
              : empty
          }
        />
      )}
      <Select
        disabled={props.disabled}
        options={[empty, ...options]}
        selectedOption={
          typeof props.value === 'string'
            ? options.find((o) => o.label === props.value) ?? empty
            : empty
        }
        invalid={!props.disabled && !valid}
        placeholder='Select...'
        onChange={(e) => {
          const { value } = e.detail.selectedOption;
          props.onChange?.(value as BrandPrefix);
        }}
      />
    </FormField>
  );
};
